export const defaultConfig = {
  retryConfig: {
    needRetry: true,
    retryArr: [2, 4, 8, 8, 8],
  },
  updateNotificationConfig: {
    needNotificate: false,
    lowestVersion: '0.0.0', // 最低版本号，如果当前版本号小于最低版本号，则不通知
  },
}
